"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.intervalDuration = exports.subtractDaysFromToday = exports.subtractMonthsFromDate = exports.duration = exports.sortObjectArrayFromDaysAgo = exports.getDateFromMonth = exports.subtract = exports.isEarlierThanToday = exports.isSameMonth = exports.getLast12Months = exports.lastUpdated = exports.dateToTimestamp = exports.getPreviousYear = exports.isDate = exports.expiry = exports.diffBetweenDatesInDays = exports.diffBetweenDatesInMonths = exports.endMonthsBetweenDates = exports.endWeeksBetweenDates = exports.getYearsFromNow = exports.toDistanceFromNowISOStrict = exports.toDistanceFromNowISO = exports.toDistanceFromNow = exports.toRelativeFromNow = exports.formatMinutes = exports.formatHours = exports.endOfWeekFromToday = exports.formatISODate = exports.dateFormat = exports.dateFormatFromStr = void 0;
var format_1 = __importDefault(require("date-fns/format"));
var endOfWeek_1 = __importDefault(require("date-fns/endOfWeek"));
var subWeeks_1 = __importDefault(require("date-fns/subWeeks"));
var formatRelative_1 = __importDefault(require("date-fns/formatRelative"));
var formatDistance_1 = __importDefault(require("date-fns/formatDistance"));
var formatDistanceStrict_1 = __importDefault(require("date-fns/formatDistanceStrict"));
var differenceInWeeks_1 = __importDefault(require("date-fns/differenceInWeeks"));
var differenceInMonths_1 = __importDefault(require("date-fns/differenceInMonths"));
var differenceInYears_1 = __importDefault(require("date-fns/differenceInYears"));
var subMonths_1 = __importDefault(require("date-fns/subMonths"));
var subYears_1 = __importDefault(require("date-fns/subYears"));
var getTime_1 = __importDefault(require("date-fns/getTime"));
var endOfMonth_1 = __importDefault(require("date-fns/endOfMonth"));
var en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
var parseISO_1 = __importDefault(require("date-fns/parseISO"));
var differenceInDays_1 = __importDefault(require("date-fns/differenceInDays"));
var sub_1 = __importDefault(require("date-fns/sub"));
var startOfMonth_1 = __importDefault(require("date-fns/startOfMonth"));
var intervalToDuration_1 = __importDefault(require("date-fns/intervalToDuration"));
var date_fns_1 = require("date-fns");
function dateFormatFromStr(date, formatStr, locale, defaultValue) {
    if (formatStr === void 0) { formatStr = "d MMM yyyy"; }
    if (locale === void 0) { locale = en_GB_1["default"]; }
    if (defaultValue === void 0) { defaultValue = "-"; }
    return dateFormat(new Date(date), formatStr, locale, defaultValue);
}
exports.dateFormatFromStr = dateFormatFromStr;
function dateFormat(date, formatStr, locale, defaultValue) {
    if (formatStr === void 0) { formatStr = "d MMM yyyy"; }
    if (locale === void 0) { locale = en_GB_1["default"]; }
    if (defaultValue === void 0) { defaultValue = "-"; }
    try {
        return (0, format_1["default"])(date, formatStr, { locale: locale });
    }
    catch (_a) {
        return defaultValue;
    }
}
exports.dateFormat = dateFormat;
function formatISODate(date, formatStr) {
    return (0, format_1["default"])((0, parseISO_1["default"])(date), formatStr, { locale: en_GB_1["default"] });
}
exports.formatISODate = formatISODate;
function endOfWeekFromToday(numberOfWeeksBack) {
    if (numberOfWeeksBack === void 0) { numberOfWeeksBack = 1; }
    return (0, endOfWeek_1["default"])((0, subWeeks_1["default"])(new Date(), numberOfWeeksBack), { locale: en_GB_1["default"] });
}
exports.endOfWeekFromToday = endOfWeekFromToday;
var formatHours = function (hours) {
    return "".concat(hours, " ").concat(hours === 1 ? "hour" : "hours");
};
exports.formatHours = formatHours;
function formatMinutes(minutes) {
    if (minutes < 60) {
        return "".concat(minutes, " min");
    }
    var hours = Math.floor(minutes / 60);
    var minutesWithoutHours = Math.round(minutes % 60);
    if (minutesWithoutHours === 0) {
        return (0, exports.formatHours)(hours);
    }
    var date = new Date(0, 0, 0, 0, minutes);
    return (0, format_1["default"])(date, "K'h' mm'm'", { locale: en_GB_1["default"] });
}
exports.formatMinutes = formatMinutes;
function toRelativeFromNow(date, customMapping) {
    if (customMapping === void 0) { customMapping = {}; }
    var mapping = __assign({ today: "'Today'", yesterday: "'Yesterday'", tomorrow: "'Tomorrow'", nextWeek: "EEEE", lastWeek: "'Last' EEEE", other: "do MMM" }, customMapping);
    var locale = __assign(__assign({}, en_GB_1["default"]), { formatRelative: function (token) { return mapping[token]; } });
    return (0, formatRelative_1["default"])(date, new Date(), { locale: locale });
}
exports.toRelativeFromNow = toRelativeFromNow;
function toDistanceFromNow(date, defaultValue, options) {
    if (defaultValue === void 0) { defaultValue = "-"; }
    if (options === void 0) { options = {}; }
    return date ? (0, formatDistance_1["default"])(date, new Date(), options) : defaultValue;
}
exports.toDistanceFromNow = toDistanceFromNow;
function toDistanceFromNowISO(date) {
    return (0, formatDistance_1["default"])((0, parseISO_1["default"])(date), new Date());
}
exports.toDistanceFromNowISO = toDistanceFromNowISO;
function toDistanceFromNowISOStrict(date) {
    return (0, formatDistanceStrict_1["default"])((0, parseISO_1["default"])(date), new Date());
}
exports.toDistanceFromNowISOStrict = toDistanceFromNowISOStrict;
function getYearsFromNow(date) {
    var today = new Date();
    return (0, differenceInYears_1["default"])(today, date);
}
exports.getYearsFromNow = getYearsFromNow;
function endWeeksBetweenDates(start, end) {
    if (!start || !end) {
        return [];
    }
    var startDate = (0, endOfWeek_1["default"])(start, { locale: en_GB_1["default"] });
    var endDate = (0, endOfWeek_1["default"])(end, { locale: en_GB_1["default"] });
    var numberOfWeeks = (0, differenceInWeeks_1["default"])(endDate, startDate);
    if (numberOfWeeks <= 0) {
        return [];
    }
    return Array.from(Array(numberOfWeeks + 1)).map(function (_, index) {
        return (0, subWeeks_1["default"])(endDate, numberOfWeeks - index);
    });
}
exports.endWeeksBetweenDates = endWeeksBetweenDates;
function endMonthsBetweenDates(start, end) {
    if (!start || !end) {
        return [];
    }
    var startDate = (0, endOfMonth_1["default"])(start);
    var endDate = (0, endOfMonth_1["default"])(end);
    var numberOfMonths = (0, differenceInMonths_1["default"])(endDate, startDate);
    if (numberOfMonths <= 0) {
        return [];
    }
    return Array.from(Array(numberOfMonths + 1)).map(function (_, index) {
        return (0, subMonths_1["default"])(endDate, numberOfMonths - index);
    });
}
exports.endMonthsBetweenDates = endMonthsBetweenDates;
function diffBetweenDatesInMonths(start, end) {
    return (0, differenceInMonths_1["default"])(new Date(end), new Date(start));
}
exports.diffBetweenDatesInMonths = diffBetweenDatesInMonths;
function diffBetweenDatesInDays(start, end) {
    return (0, differenceInDays_1["default"])(new Date(end), new Date(start));
}
exports.diffBetweenDatesInDays = diffBetweenDatesInDays;
function expiry(endDate) {
    if (!endDate)
        return "";
    var today = new Date();
    var difference = (0, differenceInMonths_1["default"])(endDate, today);
    var differenceTitle = difference === 1 ? "Month" : "Months";
    return difference < 12
        ? "".concat(difference, " ").concat(differenceTitle)
        : (0, format_1["default"])(endDate, "MMM yyyy");
}
exports.expiry = expiry;
function isDate(value) {
    return value instanceof Date && !Number.isNaN(value.valueOf());
}
exports.isDate = isDate;
var getPreviousYear = function (date) {
    return (0, getTime_1["default"])((0, subYears_1["default"])(date * 1000, 1)) / 1000;
};
exports.getPreviousYear = getPreviousYear;
function dateToTimestamp(date) {
    return isDate(date)
        ? // eslint-disable-next-line no-bitwise
            (date.getTime() / 1000) | 0
        : undefined;
}
exports.dateToTimestamp = dateToTimestamp;
var lastUpdated = function (objectData) {
    return objectData.reduce(function (latest, _a) {
        var updatedAt = _a.updatedAt;
        if (updatedAt > latest) {
            return updatedAt;
        }
        return latest;
    }, "");
};
exports.lastUpdated = lastUpdated;
var getLast12Months = function (startingFrom) {
    if (startingFrom === void 0) { startingFrom = new Date(); }
    var months = [];
    for (var i = 0; i < 12; i++) {
        var auxDate = (0, subMonths_1["default"])(startingFrom, i);
        months.push(auxDate);
    }
    return months.reverse();
};
exports.getLast12Months = getLast12Months;
var isSameMonth = function (date1, date2) {
    return (date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth());
};
exports.isSameMonth = isSameMonth;
var isEarlierThanToday = function (dateValue) {
    var date = new Date(dateValue);
    var isValid = date.getTime() === date.getTime();
    if (!isValid)
        return false;
    var today = new Date();
    return (0, differenceInDays_1["default"])(today, date) > 0;
};
exports.isEarlierThanToday = isEarlierThanToday;
var subtract = function (period, date) {
    if (date === void 0) { date = new Date(); }
    return (0, sub_1["default"])(date, period);
};
exports.subtract = subtract;
var getDateFromMonth = function (month, formatStr) {
    if (formatStr === void 0) { formatStr = "d MMM yyyy"; }
    var date = new Date();
    date.setMonth(+month - 1);
    return dateFormat(date, formatStr);
};
exports.getDateFromMonth = getDateFromMonth;
var sortObjectArrayFromDaysAgo = function (data, daysAgo) {
    var currentDate = new Date();
    var dateUTC = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - daysAgo));
    return data
        ? data
            .filter(function (item) { return new Date(item === null || item === void 0 ? void 0 : item.updatedAt) >= dateUTC; })
            .sort(function (a, b) {
            return new Date(a === null || a === void 0 ? void 0 : a.updatedAt) - new Date(b === null || b === void 0 ? void 0 : b.updatedAt);
        })
        : null;
};
exports.sortObjectArrayFromDaysAgo = sortObjectArrayFromDaysAgo;
var duration = function (s) {
    return (0, formatDistance_1["default"])(0, s * 60 * 1000, { addSuffix: false });
};
exports.duration = duration;
var subtractMonthsFromDate = function (date, months) {
    return (0, startOfMonth_1["default"])((0, subMonths_1["default"])(date, months));
};
exports.subtractMonthsFromDate = subtractMonthsFromDate;
var subtractDaysFromToday = function (days) {
    return (0, date_fns_1.subDays)(new Date(), days);
};
exports.subtractDaysFromToday = subtractDaysFromToday;
var intervalDuration = function (date) {
    var today = new Date();
    var endDate = new Date(isDate(date) || typeof date === "string" ? date : today);
    return (0, intervalToDuration_1["default"])({
        start: today,
        end: endDate
    });
};
exports.intervalDuration = intervalDuration;
